import { InternalMember } from '../member/internal-member.model';
import { CourseInstanceLocation } from './course-instance-location';
import { Course } from './course.model';
import { ScheduleAction } from './schedule-actions.model';

export class CourseInstance {
    /* Academy Properties */
    public id: string;
    public iri: string;
    public createdBy: InternalMember;
    public course: Course | string;
    public instructors: InternalMember[];
    public price: number;
    public authorNote: string;
    public remainingPlaces: number;
    public remainingAttendeeCapacity: number;
    public presentialContent: any;
    public currency: string;
    public registrations: any;
    public closed: boolean;
    public dateDeleted: string;
    public scheduleActions: ScheduleAction[];
    public language: string;
    public location: CourseInstanceLocation;
    public billable: boolean;
    public courseInstanceType: 'online' | 'presential';
    /* Exchange Properties */
    public deletedAt: string;
    public invoiceBuilding: string;
    public fullRemainingAttendeeCapacity: number;
    public isInvoiceable: boolean;
    public isInvoiceAbandoned: boolean;
    public serviceBookings?: any[];
    public roomBookings?: any[];

    constructor(json?) {
        if (json != null) {
            /* Assign Academy Properties */
            this.iri = json['@id'];
            this.id = json.id;
            this.createdBy = json.createdBy;
            this.course = json.course;
            this.instructors = json.instructors.map(instructor => new InternalMember(instructor));
            this.price = json.price;
            this.authorNote = json.authorNote;
            this.remainingPlaces = json.remainingPlaces;
            this.remainingAttendeeCapacity = json.remainingAttendeeCapacity;
            this.presentialContent = json.presentialContent;
            this.currency = json.currency;
            this.registrations = json.registrations;
            this.closed = json.closed;
            this.dateDeleted = json.dateDeleted;
            this.scheduleActions = json.scheduleActions.map(scheduleAction => new ScheduleAction(scheduleAction));
            this.language = json.language;
            this.location = json.location;
            this.billable = json.billable;
            this.courseInstanceType = json.courseInstanceType;

            /* Assign Exchange Properties */
            this.deletedAt = json.deletedAt;
            this.invoiceBuilding = json.invoiceBuilding;
            this.fullRemainingAttendeeCapacity = json.fullRemainingAttendeeCapacity;
            this.isInvoiceable = json.isInvoiceable;
            this.isInvoiceAbandoned = json.isInvoiceAbandoned;
            this.dateDeleted = json.dateDeleted;
            this.serviceBookings = json.service;
            this.roomBookings = json.roomBookings;
        }
    }

    public isFull(): boolean {
        return this.remainingPlaces <= 0;
    }
}
